import { Droppable } from "react-beautiful-dnd";
import ListItem from "./ListItem";
import React from "react";
import styled from "styled-components";

const ColumnHeader = styled.div`
  text-transform: uppercase;
  margin-bottom: 20px;
`;

const DroppableStyles = styled.div`
  padding: 10px;
  border-radius: 6px;
  background: #d4d4d4;
`;

const DraggableElement = ({ prefix, elements, dataKey }) => {
    return (<DroppableStyles>
        <ColumnHeader>{prefix}</ColumnHeader>
        <Droppable droppableId={`${prefix}`}
        >
            {(provided) => (
                <div style=
                    {{ minHeight: "600px" }} {...provided.droppableProps} ref={provided.innerRef}>
                    {elements && elements.length > 0 && elements.map((item, index) => (
                        <ListItem dataKey={dataKey} key={item.id} item={item} index={index} />
                    ))}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    </DroppableStyles>)
};

export default DraggableElement;
